import {
  useAccountActionPermissions,
  useConnectionActionPermissions,
  useCurrentUser,
} from "@zapier/client";

/**
 * Whether the user can create managed connections (admin+ on an enterprise
 * account). `isLoading` is true until the user and entitlements have loaded.
 */
export function useCanCreateManagedConnection() {
  const { canCreateManagedConnection: canByRole } =
    useConnectionActionPermissions({});
  const { isEnterprise, isLoading: isAccountLoading } =
    useAccountActionPermissions();
  const { isLoading: isUserLoading } = useCurrentUser();

  return {
    canCreateManagedConnection: canByRole && isEnterprise,
    isLoading: isUserLoading || isAccountLoading,
  };
}
